import * as types from '@/store/mutationTypes';
import _ from 'lodash';
import firebase from 'firebase';
import { NotificationTypes } from '@/types';
import router from '@/router';

const DEFAULT_TIMEOUT = 6000;

const state = {
  loading: false,
  isDrawerOpen: true,
  currentUser: {},
  showSessionModal: false,
  showUnauthorizedModal: false,
  notification: {
    message: '',
    type: NotificationTypes.SUCCESS,
    show: false,
    color: null,
    timeout: DEFAULT_TIMEOUT,
  },
};

const getters = {
  signedIn: appState => !_.isEmpty(appState.currentUser) && !appState.currentUser.isAnonymous,
  isDrawerOpen: appState => appState.isDrawerOpen || null,
  isLoading: appState => appState.loading,
  isAnonymous: appState => _.get(appState, 'currentUser.isAnonymous', false),
  isNonceUser: appState => _.get(appState, 'currentUser.nonceUser', false),
};

const mutations = {
  [types.TOGGLE_DRAWER](appState) {
    // eslint-disable-next-line no-param-reassign
    appState.isDrawerOpen = !appState.isDrawerOpen;
  },
  [types.CLEAR_APPLICATIONS_MODULE](appState) {
    // eslint-disable-next-line no-param-reassign
    appState.currentUser = {};
    // eslint-disable-next-line no-param-reassign
    appState.notification = {
      message: '',
      type: NotificationTypes.SUCCESS,
      show: false,
      color: null,
      timeout: DEFAULT_TIMEOUT,
    };
  },
  [types.SET_SESSION_MODAL](appState, show) {
    // eslint-disable-next-line no-param-reassign
    appState.showSessionModal = show;
  },
  [types.SET_UNAUTHORIZED_MODAL](appState, show) {
    // eslint-disable-next-line no-param-reassign
    appState.showUnauthorizedModal = show;
  },
  [types.SET_CURRENT_USER](appState, { currentUser }) {
    // eslint-disable-next-line no-param-reassign
    appState.currentUser = currentUser;
  },
  [types.SIGN_OUT](appState) {
    // eslint-disable-next-line no-param-reassign
    appState.currentUser = {};
  },
  [types.START_LOADING](appState) {
  // eslint-disable-next-line no-param-reassign
    appState.loading = true;
  },
  [types.END_LOADING](appState) {
    // eslint-disable-next-line no-param-reassign
    appState.loading = false;
  },
  [types.HIDE_NOTIFICATION](appState) {
    // eslint-disable-next-line no-param-reassign
    appState.notification = {
      ...appState.notification,
      show: false,
    };
  },
  [types.SET_SUCCESS_NOTIFICATION](appState, params = {}) {
    if (_.isEmpty(params) || _.isEmpty(params.message)) return;
    Object.assign(appState.notification, {
      message: params.message,
      type: NotificationTypes.SUCCESS,
      show: true,
      color: 'success',
      timeout: params.timeout || DEFAULT_TIMEOUT,
    });
  },
  [types.SET_ERROR_NOTIFICATION](appState, params = {}) {
    if (_.isEmpty(params) || _.isEmpty(params.message)) return;
    Object.assign(appState.notification, {
      message: params.message,
      type: NotificationTypes.ERROR,
      show: true,
      color: 'error',
      timeout: params.timeout || DEFAULT_TIMEOUT,
    });
  },
  [types.SET_WARNING_NOTIFICATION](appState, params = {}) {
    if (_.isEmpty(params) || _.isEmpty(params.message)) return;
    Object.assign(appState.notification, {
      message: params.message,
      type: NotificationTypes.WARNING,
      show: true,
      color: 'error',
      timeout: params.timeout || DEFAULT_TIMEOUT,
    });
  },
};

const actions = {
  toggleDrawer({ commit }) {
    commit(types.TOGGLE_DRAWER);
  },
  async addLoading({ commit }, apiCalls) {
    apiCalls.unshift(commit(types.START_LOADING));
    try {
      await Promise.all(apiCalls);
    } catch (error) {
      // dispatch('setErrorNotification', {
      //   message: error.message,
      // });
    } finally {
      commit(types.END_LOADING);
    }
  },
  setSuccessNotification({ commit }, params) {
    commit(types.SET_SUCCESS_NOTIFICATION, params || {});
  },
  setErrorNotification({ commit }, params) {
    commit(types.SET_ERROR_NOTIFICATION, params);
  },
  setWarningNotification({ commit }, params) {
    commit(types.SET_WARNING_NOTIFICATION, params);
  },
  hideNotification({ commit }) {
    commit(types.HIDE_NOTIFICATION);
  },
  showSessionModal({ commit }) {
    commit(types.SET_SESSION_MODAL, true);
  },
  hideSessionModal({ commit }) {
    commit(types.SET_SESSION_MODAL, false);
  },
  showUnauthorizedModal({ commit }) {
    commit(types.SET_UNAUTHORIZED_MODAL, true);
  },
  hideUnauthorizedModal({ commit }) {
    commit(types.SET_UNAUTHORIZED_MODAL, false);
  },
  setCurrentUser({ commit }, params) {
    commit(types.SET_CURRENT_USER, params);
  },
  signOut({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      try {
        commit(`${types.START_LOADING}`);
        firebase.auth()
          .signOut()
          .then(() => {
            dispatch('profiles/clear', null, { root: true });
            dispatch('companies/clear', null, { root: true });
            dispatch('maps/clear', null, { root: true });
            commit('CLEAR_APPLICATIONS_MODULE');
            commit(types.SIGN_OUT);

            commit(`${types.END_LOADING}`);
            router.push({ name: 'load-boards' });
            resolve();
          });
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
        commit(`${types.END_LOADING}`);
        reject(error);
      }
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/applications.js